var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiveSendClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19827 0.0782744L11.3483 2.97827C11.9937 3.17102 12.4673 3.72281 12.5598 4.39004C12.6524 5.05728 12.3469 5.71713 11.7783 6.07827L8.58827 8.07828C8.37714 8.20917 8.19917 8.38715 8.06827 8.59828L6.06827 11.7883C5.76721 12.2772 5.23241 12.573 4.65827 12.5683C3.89146 12.5736 3.21049 12.0791 2.97827 11.3483L0.0782743 2.19827C-0.111249 1.59723 0.0494039 0.940664 0.495034 0.495034C0.940664 0.0494038 1.59723 -0.111249 2.19827 0.0782744ZM7.73828 6.69827L10.9283 4.69827C10.9618 4.66672 10.9661 4.61494 10.9383 4.57827C10.9283 4.50827 10.8583 4.50827 10.8583 4.50827L1.70827 1.60827V1.66827L4.60827 10.8183C4.61851 10.8806 4.67537 10.9244 4.73827 10.9183L6.73827 7.69827C6.99713 7.29796 7.33797 6.95713 7.73828 6.69827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiveSendClick);
export default __webpack_public_path__ + "static/media/hive-send-click.d34999f73e9dee2fbfb4eb41eda13aa0.svg";
export { ForwardRef as ReactComponent };